import Vue from 'vue'
import App from './App.vue'
import Router from 'vue-router'
import router from './config/router'
import store from './store'; // 引入store
import ElementUI from 'element-ui';
import method from '@/config/api'
import request from '@/config/index'
import 'element-ui/lib/theme-chalk/index.css';
import './style.css'
import './mixin.css'

/* rem */
import '@/utils/rem.js';

import messageToast from '../components/messageToast.vue'; 
Vue.component('messageToast', messageToast);
import headerBox from '../components/headerBox.vue'; 
Vue.component('headerBox', headerBox);
import audioPlayer from '../components/audioPlayer.vue'; 
Vue.component('audioPlayer', audioPlayer);

Vue.use(Router)
Vue.use(ElementUI);

Vue.config.productionTip = false;
Vue.prototype.$method = method;
Vue.prototype.$postRequest = request.post;
Vue.prototype.$getRequest = request.get;
Vue.prototype.$imgurl = request.baseURL;

import Sticky from 'vue-sticky-directive';
Vue.use(Sticky);

// swiper切换
import VueAwesomeSwiper from "vue-awesome-swiper";
import "swiper/css/swiper.css";
Vue.use(VueAwesomeSwiper);

// 发布者订阅 公共bus
const Bus = new Vue();
export default Bus;
Vue.prototype.$bus = new Vue()

document.title = '英涯绘'

router.afterEach((to, from, next) => {
  window.scrollTo(0, 0)
})

new Vue({
  store,
  router,
  render: h => h(App),
}).$mount('#app')
